import ConstructionIcon from './component'

export default ConstructionIcon
